// Work planning routes
export default [
  {
    path: 'groupings-info',
    name: 'groupingInfo',
    component: () =>
      import(
        /* webpackChunkName: "groupingInfo" */ '../views/groupings/SampleGroupingIndex.vue'
      ),
    meta: {
      tabbable: true,
      tableKeys: ['groupings'],
      filterKeys: ['groupings'],
      formKeys: [],
      routePermissions: ['receivedSamplesView'],
    },
  },
];
